import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PublicShell = ({ children }) => {
  const { authStatus } = useAuth();
  const loggedIn = authStatus === 'approved';

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <header className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-3 shrink-0">
            <img src="/logo192.png" alt="Car Wash Copilot" className="w-8 h-8" />
            <span className="text-lg font-semibold text-gray-900">Car Wash Copilot</span>
          </Link>
          <nav className="flex items-center gap-2 sm:gap-4 text-sm">
            <Link to="/messaging-consent" className="hidden md:inline text-gray-600 hover:text-gray-900">Messaging</Link>
            <Link to="/sms-opt-in" className="hidden md:inline text-gray-600 hover:text-gray-900">SMS Opt-In</Link>
            <Link to="/security" className="hidden md:inline text-gray-600 hover:text-gray-900">Security</Link>
            <Link to="/contact" className="hidden md:inline text-gray-600 hover:text-gray-900">Contact</Link>
            {loggedIn ? (
              <Link
                to="/"
                className="bg-blue-600 hover:bg-blue-700 text-white px-3 sm:px-4 py-2 rounded-md text-sm font-medium"
              >
                Go to Dashboard
              </Link>
            ) : (
              <Link
                to="/login"
                className="bg-blue-600 hover:bg-blue-700 text-white px-3 sm:px-4 py-2 rounded-md text-sm font-medium"
              >
                Log in
              </Link>
            )}
          </nav>
        </div>
      </header>

      <main className="flex-1 max-w-5xl w-full mx-auto px-4 sm:px-6 py-8 sm:py-12">
        {children}
      </main>

      <footer className="bg-white border-t border-gray-200">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-6 text-xs text-gray-500 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p>&copy; {new Date().getFullYear()} Winborne Software LLC. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <Link to="/messaging-consent" className="hover:text-gray-700">Messaging Terms</Link>
            <Link to="/security" className="hover:text-gray-700">Security</Link>
            <Link to="/contact" className="hover:text-gray-700">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PublicShell;
